import React from 'react';
//Third-party packages
import { styled } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  Drawer as MuiDrawer,
  List,
  Toolbar,
  Divider,
  useMediaQuery,
  useTheme,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@material-ui/core';

//import Demo from './SwipableDrawer'

//Custom imports
import { menuItems } from '../../helpers/loadMenuRol';
import { navigate } from '@reach/router';
import { Drawer as DrawerMobile } from '@mui/material';
import { uiManageModal } from '../../redux/actions/ui';
import { AccountBox, DescriptionOutlined, ExitToAppOutlined } from '@material-ui/icons';
import { startLogOut } from '../../redux/actions/auth';
import { startResetPage } from '../../redux/actions/sales';
import { startResetLinesPage } from '../../redux/actions/lines';
import { ROLADMIN, ROLREVENDEDOR } from '../../utils/constants';

/**
 * Author: QBK
 * Date: 22-09-2021
 */

const drawerWidth = 200;
const menuTextStyle = { fontSize: '17px' };
const menuIconStyle = { minWidth: '38px' };

//Drawer component
/**
 * We styles the paper using basically transitions. We get this using the transitions.create props
 * from the theme material-ui prop
 * Also, we manage the spacing based on the ui size
 */
const Drawer = styled(MuiDrawer, { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    top: 64,
    height: 'calc(100% - 64px)',
    overflowY: 'auto',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: 0, //theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        width: 0, // theme.spacing(9),
      },
    }),
  },
}));

export const DrawerNav = () => {
  const { menuState } = useSelector(state => state.ui); //we get the state (true or false) from the redux state
  const theme = useTheme(); // to get the theme
  const matcheXS = useMediaQuery(theme.breakpoints.down('md')); //if the screen side is less than XSS, matchesXS is true
  const dispatch = useDispatch();
  const { idRol } = useSelector(state => state.auth);
  const handleNavigation = route => {
    navigate(route);
    dispatch(startResetPage());
    dispatch(startResetLinesPage());
  };
  const handleLogOut = () => {
    dispatch(startLogOut());
  };
  //Rendered HTML. Based on the screen size, we render or the <Demo /> component or the <Drawer component />
  return matcheXS ? (
    <React.Fragment>
      <DrawerMobile anchor="left" open={menuState} variant="temporary" ModalProps={{ keepMounted: true }}>
        <Box
          sx={250}
          role="presentation"
          onClick={() => dispatch(uiManageModal())}
          onKeyDown={() => dispatch(uiManageModal())}>
          <List>
            {menuItems.map((element, index) => {
              let result = element.role.filter(role => role === idRol);
              if (result.includes(idRol)) {
                return (
                  <ListItem
                    key={index}
                    button
                    onClick={() => handleNavigation(element.route)}
                    style={index === 0 && idRol === ROLREVENDEDOR ? { paddingTop: '1.75rem' } : undefined}>
                    <ListItemIcon style={menuIconStyle}>{element.icon}</ListItemIcon>
                    <ListItemText
                      variant="h3"
                      primary={element.name}
                      color="#000"
                      primaryTypographyProps={{ style: menuTextStyle }}
                    />
                  </ListItem>
                );
              }
              return null;
            })}
            {idRol === ROLADMIN && (
              <ListItem button onClick={() => handleNavigation('/gestor-documental')}>
                <ListItemIcon style={menuIconStyle}>
                  <DescriptionOutlined />
                </ListItemIcon>
                <ListItemText
                  variant="h3"
                  primary="Gestor Doc."
                  color="#000"
                  primaryTypographyProps={{ style: menuTextStyle }}
                />
              </ListItem>
            )}
            <ListItem button onClick={() => navigate(`/me`)}>
              <ListItemIcon style={menuIconStyle}>
                <AccountBox />
              </ListItemIcon>
              <ListItemText
                variant="h3"
                primary="Perfil"
                color="#000"
                primaryTypographyProps={{ style: menuTextStyle }}
              />
            </ListItem>

            <ListItem button onClick={() => handleLogOut()}>
              <ListItemIcon style={menuIconStyle}>
                <ExitToAppOutlined />
              </ListItemIcon>
              <ListItemText
                variant="h3"
                primary="Salir"
                color="#000"
                primaryTypographyProps={{ style: menuTextStyle }}
              />
            </ListItem>
          </List>
        </Box>
      </DrawerMobile>
    </React.Fragment>
  ) : (
    <Drawer variant="permanent" anchor="left" open={menuState}>
      <Divider />
      <List>
        <div>
          {menuItems.map((element, index) => {
            let result = element.role.filter(role => role === idRol);
            if (result.includes(idRol)) {
              return (
                <ListItem key={index} button onClick={() => handleNavigation(element.route)}>
                  <ListItemIcon style={menuIconStyle}>{element.icon}</ListItemIcon>
                  <ListItemText
                    variant="h3"
                    primary={element.name}
                    color="#000"
                    primaryTypographyProps={{ style: menuTextStyle }}
                  />
                </ListItem>
              );
            }
            return null;
          })}
          {idRol === ROLADMIN && (
            <ListItem button onClick={() => handleNavigation('/gestor-documental')}>
              <ListItemIcon style={menuIconStyle}>
                <DescriptionOutlined />
              </ListItemIcon>
              <ListItemText
                variant="h3"
                primary="Gestor Doc."
                color="#000"
                primaryTypographyProps={{ style: menuTextStyle }}
              />
            </ListItem>
          )}
          <ListItem button onClick={() => navigate(`/me`)}>
            <ListItemIcon style={menuIconStyle}>
              <AccountBox />
            </ListItemIcon>
            <ListItemText
              variant="h3"
              primary="Perfil"
              color="#000"
              primaryTypographyProps={{ style: menuTextStyle }}
            />
          </ListItem>

          <ListItem button onClick={() => handleLogOut()}>
            <ListItemIcon style={menuIconStyle}>
              <ExitToAppOutlined />
            </ListItemIcon>
            <ListItemText variant="h3" primary="Salir" color="#000" primaryTypographyProps={{ style: menuTextStyle }} />
          </ListItem>
        </div>
      </List>
    </Drawer>
  );
};
